import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
    loading: false,
    reports: {},
    error: null,
};

const ReportsReducer = (state = initialState, action) => {
    // get all reports
    switch (action.type) {
        case actionTypes.REPORTS_LIST_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.REPORTS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                reports: action.payload,
                error: null,
            };
        case actionTypes.REPORTS_LIST_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default ReportsReducer;
